module.exports = __webpack_public_path__ + "../assets/img/fold4.904b8e58.png";